/**
 * Constructs a SIP URI for blind transfer operations.
 *
 * - External numbers: strips all characters except digits (0-9), plus (+), asterisk (*), and hash (#)
 * - Internal routes (prefixed with "pr" or "room"): preserves the destination unchanged
 * - Produces format: sip:{sanitizedDestination}@{domain} with no whitespace
 */
export function buildTransferUri(destination: string, domain: string): string {
  // Preserve internal routing prefixes (pr = person, room = conference)
  const isInternalRoute = /^(pr|room)/.test(destination);

  const sanitized = isInternalRoute
    ? destination
    : destination.replace(/[^0-9+*#]/g, '');

  return `sip:${sanitized}@${domain}`.replace(/\s/g, '');
}
